// Vendor imports
const React = require('react')
// Client V2 common imports
const DownloadButton = require('client-v2/into-landing/containers/download-button/component-smart')
const useToggleState = require('client-v2/common/hooks/toggle-state')
// Entry imports
const UserListModal = require('client-v2/into-landing/components/user-list-modal')
const IntoHeader = require('client-v2/into-landing/containers/header/component-smart')
const TopicProfileFeed = require('./containers/feed/component-smart')
const SMSModal = require('client-v2/into-landing/containers/sms-modal/component-smart')

function IntoTopicProfileLayout(props) {
  const { feedItems, topic, showSMSModal, onPaginate } = props
  const [ isBlurred, toggleBlurred ] = useToggleState(false)
  const [ isUserModalVisible, toggleUserModalVisible ] = useToggleState(false)
  const [ extraItemsNum, setExtraItemsNum ] = React.useState(0)

  React.useEffect(
    () => {
      function getNumberOfExtraItems() {
        const parent = document.querySelector('.grid')
        // TODO: find a better way of doing this
        const gridItem = document.querySelector('.grid-item')
        if (!parent || !gridItem) {
          return
        }
        const gridWidth = parent.offsetWidth
        const gridItemSize = gridItem.offsetWidth
        const itemsPerRow = Math.floor(gridWidth / gridItemSize)
        const numExtra = feedItems.size % itemsPerRow
        setExtraItemsNum(numExtra)
      }

      window.setTimeout(getNumberOfExtraItems, 1)
      window.addEventListener('resize', getNumberOfExtraItems)
      return () => {
        window.removeEventListener('resize', getNumberOfExtraItems)
      }
    },
    [ feedItems, setExtraItemsNum ]
  )

  const handleSMSModal = React.useCallback(
    () => {
      toggleBlurred()
      showSMSModal({
        deeplinkData: null,
        isDownloadPromptVisible: false
      })
    },
    [ toggleBlurred, showSMSModal ]
  )

  const handleViewClick = React.useCallback(
    () => {
      toggleUserModalVisible()
    },
    [ toggleUserModalVisible ]
  )

  return (
    <React.Fragment>
      <SMSModal isBlurred={isBlurred} onDismiss={handleSMSModal} dismissOnOuterClick={true} />
      <div className={`flex flex-col h-screen md:overflow-hidden ${isBlurred ? 'blur-lg' : ''}`}>
        <IntoHeader onDownloadClick={handleSMSModal} />
        <div className="space-y-10 md:space-y-0 md:space-x-10 flex-1 overflow-y-scroll">
          <div className="md:w-80 md:float-left p-6 pt-0 md:pt-6 md:sticky md:top-0">
            <div className="space-y-10">
              <div className="space-y-6">
                <p className="leading-tight text-3xl font-medium">{topic.name}</p>
                <DownloadButton
                  className="btn btn-primary btn-dot"
                  buttonText="Follow"
                  onClick={handleSMSModal}
                />
              </div>
              {topic.followers && topic.followers.size > 0 && (
                <div>
                  <div className="flex mb-4">
                    <p className="flex-1 font-medium opacity-50">Followed by</p>
                    {topic.followers.size > 4 && (
                      <button
                        className="btn btn-link text-sm font-normal text-orange-500"
                        onClick={handleViewClick}
                      >
                        View all
                      </button>
                    )}
                  </div>
                  <div className="mb-6 space-y-4">
                    {topic.followers.slice(0, 4).map(follower => (
                      <a
                        key={follower.username}
                        href={`/${follower.username}`}
                        className="flex items-center space-x-4"
                      >
                        <img
                          className="shrink-0 inline-block aspect-square object-cover rounded-full w-14"
                          src={follower['photo_url']}
                          alt={follower['display_name']}
                        />
                        <div className="flex-1 flex flex-col min-w-0">
                          <p className="font-medium truncate">{follower['display_name']}</p>
                          <p className="text-sm truncate opacity-50 mb-1">{`@${follower.username}`}</p>
                        </div>
                        <button className="btn btn-square">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="aspect-square w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 4v16m8-8H4"
                            ></path>
                          </svg>
                        </button>
                      </a>
                    ))}
                  </div>
                </div>
              )}
              {topic.related && topic.related.size > 0 && (
                <div>
                  <p className="font-medium opacity-50 mb-3">Related topics</p>
                  <div className="flex flex-wrap gap-2 h-6 mb-4 overflow-hidden">
                    <div className="flex flex-wrap overflow-hidden">
                      {topic.related.map(item => (
                        <a
                          key={item.slug}
                          href={`/topic/${item.slug}`}
                          className="btn btn-link relative z-10"
                        >
                          <span className="tag mr-2 mb-2">{item.name}</span>
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="flex-1 overflow-hidden">
            <TopicProfileFeed
              items={feedItems.slice(0, feedItems.size - extraItemsNum)}
              onPaginate={onPaginate}
            />
            <div className="text-center p-4 lg:p-6 shrink-0">
              <p className="text-sm mb-3 font-medium opacity-75">Sign up to see all content</p>
              <DownloadButton
                className="btn btn-primary btn-dot"
                buttonText="Get the App"
                onClick={handleSMSModal}
              />
            </div>
          </div>
        </div>
      </div>
      {topic.followers && topic.followers.size > 0 && (
        <UserListModal
          handleSMSModal={handleSMSModal}
          isModalVisible={isUserModalVisible}
          onDismiss={toggleUserModalVisible}
          caption={`${topic.followers.size} Followers`}
          users={topic.followers}
        />
      )}
      <div id="modal-container"></div>
      <div
        id="svelte-announcer"
        aria-live="assertive"
        aria-atomic="true"
        style={{
          position: 'absolute',
          left: '0',
          top: '0',
          clip: 'rect(0, 0, 0, 0)',
          clipPath: 'inset(50%)',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          width: '1px',
          height: '1px'
        }}
      ></div>
    </React.Fragment>
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const Immutable = require('immutable')

  IntoTopicProfileLayout.propTypes = {
    feedItems: PropTypes.instanceOf(Immutable.Iterable),
    topic: PropTypes.object.isRequired,
    showSMSModal: PropTypes.func,
    onPaginate: PropTypes.func
  }
}

module.exports = IntoTopicProfileLayout
